import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import gsap from 'gsap';
import ScrollHint from 'scroll-hint';
import 'scroll-hint/css/scroll-hint.css';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  new ScrollHint('.js-scrollable', {
    i18n: {
      scrollable: 'スクロールできます',
    },
  });

// お問い合わせ用バリデーション（contactページのみ実行）
if (document.body.classList.contains('contact')) {
  topValidation();
}

  const faqItems = document.querySelectorAll('.cmn_faq_item');
  faqItems.forEach((faqItem) => {
    const toggleButton = faqItem.querySelector('.js-cmn-faq-toggle');
    const answerPanel = faqItem.querySelector('.cmn_faq_a_outer');
    if (!toggleButton || !answerPanel) {
      return;
    }

    // Initial state: show only question rows.
    faqItem.classList.remove('is-open');
    toggleButton.setAttribute('aria-expanded', 'false');
    answerPanel.hidden = true;

    const animateClose = () => {
      const currentHeight = answerPanel.scrollHeight;
      answerPanel.style.height = `${currentHeight}px`;

      requestAnimationFrame(() => {
        answerPanel.style.height = '0px';
      });

      const handleCloseEnd = (event) => {
        if (event.propertyName !== 'height') {
          return;
        }
        answerPanel.hidden = true;
        answerPanel.style.height = '0px';
        answerPanel.removeEventListener('transitionend', handleCloseEnd);
      };

      answerPanel.addEventListener('transitionend', handleCloseEnd);
    };

    const animateOpen = () => {
      answerPanel.hidden = false;
      answerPanel.style.height = '0px';

      requestAnimationFrame(() => {
        const targetHeight = answerPanel.scrollHeight;
        answerPanel.style.height = `${targetHeight}px`;
      });

      const handleOpenEnd = (event) => {
        if (event.propertyName !== 'height') {
          return;
        }
        if (faqItem.classList.contains('is-open')) {
          answerPanel.style.height = 'auto';
        }
        answerPanel.removeEventListener('transitionend', handleOpenEnd);
      };

      answerPanel.addEventListener('transitionend', handleOpenEnd);
    };

    toggleButton.addEventListener('click', () => {
      const isOpen = faqItem.classList.contains('is-open');
      if (isOpen) {
        faqItem.classList.remove('is-open');
        toggleButton.setAttribute('aria-expanded', 'false');
        animateClose();
        return;
      }

      faqItem.classList.add('is-open');
      toggleButton.setAttribute('aria-expanded', 'true');
      animateOpen();
    });
  });

  const scaleRevealItems = document.querySelectorAll(
    '.cmn_section_gallery_item, .index_service_img, .curriculum_list_item, .voice_img_wrap, .staff_list_item',
  );
  if (scaleRevealItems.length > 0) {
    const revealScaleItem = (itemEl) => {
      gsap.to(itemEl, {
        autoAlpha: 1,
        keyframes: [
          {
            scale: 1.03,
            duration: 0.36,
            ease: 'power2.out',
          },
          {
            scale: 1,
            duration: 0.24,
            ease: 'power1.out',
          },
        ],
      });
    };

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion || !('IntersectionObserver' in window)) {
      gsap.set(scaleRevealItems, { autoAlpha: 1, scale: 1, clearProps: 'opacity,transform,visibility' });
    } else {
      gsap.set(scaleRevealItems, {
        autoAlpha: 0,
        scale: 0.85,
        transformOrigin: 'center center',
      });

      const scaleRevealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            revealScaleItem(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          threshold: 0.2,
          rootMargin: '0px 0px -8% 0px',
        },
      );

      scaleRevealItems.forEach((itemEl) => {
        scaleRevealObserver.observe(itemEl);
      });
    }
  }

  const cmnTitleList = document.querySelectorAll('.cmn_ttl');
  if (cmnTitleList.length > 0) {
    cmnTitleList.forEach((titleEl) => {
      const jaEl = titleEl.querySelector('.cmn_ttl_ja');
      const enEl = titleEl.querySelector('.cmn_ttl_en');
      if (!jaEl && !enEl) {
        return;
      }

      titleEl.classList.add('js-ttl-animate');

      if (jaEl && !jaEl.dataset.splitReady) {
        const chars = [...(jaEl.textContent || '')];
        jaEl.innerHTML = '';
        chars.forEach((char, index) => {
          const span = document.createElement('span');
          span.className = 'cmn_ttl_ja_char';
          span.innerHTML = char === ' ' ? '&nbsp;' : char;
          span.style.setProperty('--cmn-ttl-char-delay', `${(0.08 + index * 0.045).toFixed(2)}s`);
          jaEl.appendChild(span);
        });
        jaEl.dataset.splitReady = 'true';
      }
    });

    const revealTitle = (titleEl) => {
      titleEl.classList.add('is-inview');
    };

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion || !('IntersectionObserver' in window)) {
      cmnTitleList.forEach((titleEl) => {
        revealTitle(titleEl);
      });
    } else {
      const titleObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            revealTitle(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          threshold: 0.22,
          rootMargin: '0px 0px -10% 0px',
        },
      );

      cmnTitleList.forEach((titleEl) => {
        titleObserver.observe(titleEl);
      });
    }
  }

  const initLeadTitleAnimation = () => {
    const cmnLeadTitleList = document.querySelectorAll('.cmn_lead_ttl');
    if (cmnLeadTitleList.length === 0) {
      return;
    }

    const revealLeadTitle = (leadTitleEl) => {
      gsap.to(leadTitleEl, {
        autoAlpha: 1,
        y: 0,
        duration: 0.75,
        ease: 'power3.out',
        clearProps: 'opacity,transform',
      });
    };

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion || !('IntersectionObserver' in window)) {
      cmnLeadTitleList.forEach((leadTitleEl) => {
        gsap.set(leadTitleEl, { clearProps: 'opacity,transform,visibility' });
      });
      return;
    }

    gsap.set(cmnLeadTitleList, { autoAlpha: 0, y: -28 });

    const leadTitleObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          revealLeadTitle(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px',
      },
    );

    cmnLeadTitleList.forEach((leadTitleEl) => {
      leadTitleObserver.observe(leadTitleEl);
    });
  };

  const initLeadImageAnimation = () => {
    const cmnLeadImageList = document.querySelectorAll('.cmn_lead_img, .js-zoomout-reveal');
    if (cmnLeadImageList.length === 0) {
      return;
    }

    const revealLeadImage = (leadImageEl) => {
      const leadImage = leadImageEl.matches('img') ? leadImageEl : leadImageEl.querySelector('img');
      const tl = gsap.timeline();

      tl.to(leadImageEl, {
        autoAlpha: 1,
        duration: 0.36,
        ease: 'power2.out',
        clearProps: 'opacity,visibility',
      });

      if (leadImage) {
        tl.to(
          leadImage,
          {
            scale: 1,
            duration: 1.0,
            ease: 'power3.out',
            clearProps: 'transform',
          },
          0,
        );
      }
    };

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion || !('IntersectionObserver' in window)) {
      cmnLeadImageList.forEach((leadImageEl) => {
        gsap.set(leadImageEl, { clearProps: 'opacity,visibility' });
        const leadImage = leadImageEl.matches('img') ? leadImageEl : leadImageEl.querySelector('img');
        if (leadImage) {
          gsap.set(leadImage, { clearProps: 'transform' });
        }
      });
      return;
    }

    gsap.set(cmnLeadImageList, {
      autoAlpha: 0,
    });

    cmnLeadImageList.forEach((leadImageEl) => {
      const leadImage = leadImageEl.matches('img') ? leadImageEl : leadImageEl.querySelector('img');
      if (!leadImage) {
        return;
      }
      gsap.set(leadImage, {
        scale: 1.14,
        transformOrigin: 'center center',
      });
    });

    const leadImageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          revealLeadImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        threshold: 0.14,
        rootMargin: '0px 0px -8% 0px',
      },
    );

    cmnLeadImageList.forEach((leadImageEl) => {
      leadImageObserver.observe(leadImageEl);
    });
  };

  const initCoordinationChartAnimation = () => {
    const chartList = document.querySelectorAll('.coordination_chart');
    if (chartList.length === 0) {
      return;
    }

    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isReducedMotion || !('IntersectionObserver' in window)) {
      chartList.forEach((chartEl) => {
        const ringEl = chartEl.querySelector('.chart_ring');
        const orbitEl = chartEl.querySelector('.chart_items_wrapper');
        const centerTextEl = chartEl.querySelector('.chart_center_txt');
        const allItems = chartEl.querySelectorAll('.chart_item');
        gsap.set([ringEl, orbitEl, centerTextEl, ...allItems], {
          clearProps: 'opacity,transform,visibility',
        });
      });
      return;
    }

    const orderedSelectors = [
      '.item_identification',
      '.item_orientation',
      '.item_conversion',
      '.item_rhythm',
      '.item_coupling',
      '.item_balance',
      '.item_reaction',
    ];

    chartList.forEach((chartEl) => {
      const ringEl = chartEl.querySelector('.chart_ring');
      const orbitEl = chartEl.querySelector('.chart_items_wrapper');
      const centerTextEl = chartEl.querySelector('.chart_center_txt');
      const orderedItems = orderedSelectors
        .map((selector) => chartEl.querySelector(selector))
        .filter(Boolean);

      if (!ringEl || !orbitEl || !centerTextEl || orderedItems.length === 0) {
        return;
      }

      gsap.set([ringEl, orbitEl], {
        autoAlpha: 0,
        scale: 0.86,
        transformOrigin: 'center center',
      });

      gsap.set(centerTextEl, {
        autoAlpha: 0,
        scale: 0.9,
        y: -10,
        transformOrigin: 'center center',
      });

      gsap.set(orderedItems, {
        autoAlpha: 0,
        scale: 0.58,
        y: 10,
        transformOrigin: 'center center',
      });

      const chartObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            const tl = gsap.timeline();

            // 1) グラデ円と半透明の円軌道を同時にポヨン表示
            tl.to([ringEl, orbitEl], {
              autoAlpha: 1,
              scale: 1,
              duration: 0.4,
              ease: 'back.out(1.25)',
            });

            // 2) 中央テキストを次に表示
            tl.to(centerTextEl, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.28,
              ease: 'back.out(1.2)',
            }, '>-0.02');

            // 3) 識別能力から時計回りで1つずつ表示
            tl.to(orderedItems, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.24,
              ease: 'back.out(1.18)',
              stagger: 0.11,
            }, '>+0.03');

            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          threshold: 0.3,
          rootMargin: '0px 0px -8% 0px',
        },
      );

      chartObserver.observe(chartEl);
    });
  };

  initLeadTitleAnimation();
  initLeadImageAnimation();
  initCoordinationChartAnimation();
});


// ===================================================
// ハンバーガーメニューの開閉
// ===================================================
var hamburger = document.querySelector('.menu-trigger');
var nav = document.querySelector('.nav');
if (hamburger && nav) {
  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('js-open');
    nav.classList.toggle('js-open');
  });
}